import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { queryClient } from '@/api/queryClient';
import { AbilityProvider } from '@/auth/AbilityProvider';
import { AuthProvider } from '@/auth/AuthProvider';
import { TenantAccessProvider } from '@/auth/tenant-access/TenantAccessProvider';
import { router } from '@/routes';

import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AbilityProvider>
          <TenantAccessProvider>
            <RouterProvider router={router} />
          </TenantAccessProvider>
        </AbilityProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
